import { SenderDomain } from "./SenderDomain.js";
export let Campaign;
(function (_Campaign) {
  const SenderDomainVerificationFlow = _Campaign.SenderDomainVerificationFlow = SenderDomain.VerificationFlowVersion;
  let LifecycleStatus = /*#__PURE__*/function (LifecycleStatus) {
    LifecycleStatus["DRAFT"] = "draft";
    LifecycleStatus["SCHEDULED"] = "scheduled";
    LifecycleStatus["PENDING"] = "pending";
    LifecycleStatus["SENT"] = "sent";
    return LifecycleStatus;
  }({});
  _Campaign.LifecycleStatus = LifecycleStatus;
  let StoryAlignment = /*#__PURE__*/function (StoryAlignment) {
    StoryAlignment["CENTER"] = "center";
    StoryAlignment["LEFT"] = "left";
    StoryAlignment["RIGHT"] = "right";
    return StoryAlignment;
  }({});
  _Campaign.StoryAlignment = StoryAlignment;
  let StoryAppearance = /*#__PURE__*/function (StoryAppearance) {
    StoryAppearance["INTRO"] = "intro";
    StoryAppearance["FULL"] = "full";
    return StoryAppearance;
  }({});
  _Campaign.StoryAppearance = StoryAppearance;
  let StoryHeaderFooter = /*#__PURE__*/function (StoryHeaderFooter) {
    StoryHeaderFooter["NONE"] = "none";
    StoryHeaderFooter["STANDARD"] = "standard";
    StoryHeaderFooter["FULL"] = "full";
    return StoryHeaderFooter;
  }({});
  _Campaign.StoryHeaderFooter = StoryHeaderFooter;
  let SenderDomainVerificationStatus = /*#__PURE__*/function (SenderDomainVerificationStatus) {
    SenderDomainVerificationStatus["UNKNOWN"] = "unknown";
    SenderDomainVerificationStatus["VALID"] = "valid";
    SenderDomainVerificationStatus["INVALID"] = "invalid";
    SenderDomainVerificationStatus["NOT_APPLICABLE"] = "not-applicable";
    return SenderDomainVerificationStatus;
  }({});
  _Campaign.SenderDomainVerificationStatus = SenderDomainVerificationStatus;
  let ClickTrackingVersion = /*#__PURE__*/function (ClickTrackingVersion) {
    ClickTrackingVersion[ClickTrackingVersion["DEPRECATED"] = 1] = "DEPRECATED";
    ClickTrackingVersion[ClickTrackingVersion["ENHANCED"] = 2] = "ENHANCED";
    return ClickTrackingVersion;
  }({});
  _Campaign.ClickTrackingVersion = ClickTrackingVersion;
  function isDraft(arg) {
    if (typeof arg === 'object') {
      return isDraft(arg.lifecycle_status);
    }
    return arg === LifecycleStatus.DRAFT;
  }
  _Campaign.isDraft = isDraft;
  function isScheduled(arg) {
    if (typeof arg === 'object') {
      return isScheduled(arg.lifecycle_status);
    }
    return arg === LifecycleStatus.SCHEDULED;
  }
  _Campaign.isScheduled = isScheduled;
  function isPending(arg) {
    if (typeof arg === 'object') {
      return isPending(arg.lifecycle_status);
    }
    return arg === LifecycleStatus.PENDING;
  }
  _Campaign.isPending = isPending;
  function isSent(arg) {
    if (typeof arg === 'object') {
      return isSent(arg.lifecycle_status);
    }
    return arg === LifecycleStatus.SENT;
  }
  _Campaign.isSent = isSent;
})(Campaign || (Campaign = {}));